

































import Vue from 'vue';
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue';
import Spinner from '@/components/Spinner';

export default Vue.extend({
    components: { SvgIcon, Spinner },

    name: 'Checkbox',

    model: {
        prop: 'checked',
        event: 'change',
    },

    props: {
        name: String,
        value: String,
        checked: Boolean,
        disabled: Boolean,
        loading: Boolean,
    },
});
